<template>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>device_thermostat</md-icon>
          </div>
          <p class="category">Senzor teploty T104</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'T104')?.value ?? 0"
              :duration="1000"
            />
            °C
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Teplota privádzanej odpadovej vody
          </div>
        </template> 
      </stats-card>
    </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>device_thermostat</md-icon>
          </div>
          <p class="category">Senzor teploty T103</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'T103')?.value ?? 0"
              :duration="1000"
            />
            °C
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Teplota vychladenej odpadovej vody
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>device_thermostat</md-icon>
          </div>
          <p class="category">Senzor teploty T411</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'T411')?.value ?? 0"
              :duration="1000"
            />
            °C
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Teplota teplej vody dodávanej do objektu
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>device_thermostat</md-icon>
          </div>
          <p class="category">Senzor teploty T600</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'T600')?.value ?? 0"
              :duration="1000"
            />
            °C
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Aktuálna teplota vonkajšieho prostredia
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>device_thermostat</md-icon>
          </div>
          <p class="category">Senzor teploty T609</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'T609')?.value ?? 0"
              :duration="1000"
            />
            °C
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Priemerná teplota vzduchu v objekte
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>bolt</md-icon>
          </div>
          <p class="category">Merač energie M31</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'M31')?.value ?? 0"
              :duration="1000"
            />
            kWh
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Teplo z odpadu na vykurovanie objektu
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>bolt</md-icon>
          </div>
          <p class="category">Merač energie M32</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'M32')?.value ?? 0"
              :duration="1000"
            />
            kWh
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Teplo z odpadu na vykurovanie objektu
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>bolt</md-icon>
          </div>
          <p class="category">Merač energie M51</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'M51')?.value ?? 0"
              :duration="1000"
            />
            kWh
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Teplo od dodávateľa na vykurovanie objektu
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>bolt</md-icon>
          </div>
          <p class="category">Merač energie MEL</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'MEL')?.value ?? 0"
              :duration="1000"
            />
            kWh
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Spotrebovaná elektrická energia na cirkuláciu
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="rose">
        <template slot="header">
          <div class="card-icon">
            <md-icon>water</md-icon>
          </div>
          <p class="category">Prietokový merač M41</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'M41')?.value ?? 0"
              :duration="1000"
            />
            m&sup3;
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Množstvo pitnej vody na prípravu teplej vody
          </div>
        </template> 
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="rose">
        <template slot="header">
          <div class="card-icon">
            <md-icon>water</md-icon>
          </div>
          <p class="category">Prietokový merač M42</p>
          <h3 class="title">
            <animated-number
              :value="sensors.find(s => s.id === 'M42')?.value ?? 0"
              :duration="1000"
            />
            m&sup3;
          </h3>
        </template>  
        <template slot="footer">
          <div>
            Množstvo vody od teplárenskej spoločnosti
          </div>
        </template> 
      </stats-card>
    </div>

    
  </div>
</template>
  
  <script>
import axios from "axios";
import { sensors as sensorDefinitions } from "@/utils/userInfo.js";
import { StatsCard, AnimatedNumber } from "@/components";

export default {
  components: {
    StatsCard,
    AnimatedNumber,
  },
  name: "TemperatureSchema",
  data() {
    return {
      refreshInterval: null,
      sensorPositions: {
        T103: { top: "64%", left: "27%" },
        T600: { top: "11%", left: "26%" },
        T609: { top: "17%", left: "26%" },
        T411: { top: "29%", left: "65%" },
        T104: { top: "56%", left: "27%" },
        MEL: { top: "1%", left: "110%" },
        M31: { top: "5%", left: "110%" },
        M32: { top: "9%", left: "110%" },
        M41: { top: "13%", left: "110%" },
        M42: { top: "17%", left: "110%" },
        M51: { top: "21%", left: "110%" },
      },
      sensors: sensorDefinitions.map((s) => ({
        ...s,       // copy id, name, path, type
        value: null,
        offline: true,
      })),
    };
  },
  mounted() {
    this.fetchData();
    this.refreshInterval = setInterval(this.fetchData, 60000);
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },
  methods: {
    async fetchData() {
      const now = new Date();
      const start =
        new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() /
        1000;
      const end = start + 86400 - 60;

      for (const sensor of this.sensors) {
        try {
          const response = await axios.post(
            "https://devel.ceelabs.com/energiareal/Data.php",
            {
              start,
              end,
              deviceID: sensor.id,
            }
          );

          const stats = response.data.statistics;

          if (!stats || typeof stats.LAST !== "number") {
            sensor.offline = true;
            sensor.value = null;
          } else {
            sensor.offline = false;
            sensor.value = stats.LAST;
          }
        } catch (error) {
          sensor.offline = true;
          sensor.value = null;
        }
      }
    },
  },
};
</script>
<style scoped>
form {
  display: flex;
  width: 100%;
  gap: 8px; /* Add space between the input and button */
  align-items: center; /* Vertically center the input and button */
}

/* Input field takes all available width and adjusted height */
.input-field {
  flex-grow: 1;
  height: 40px; /* Set a fixed height for better alignment with the button */
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  line-height: 24px; /* Ensure text is vertically centered */
}

/* Optional style overrides */
.bg-blue-600 {
  background-color: #4c8bf5;
  text-align: right;
  padding-right: 10px;
}

/* Container bar background */
.bg-gray-200 {
  background-color: #e5e7eb;
}

/* Colors for sections */
.bg-green-600 {
  background-color: #16a34a;
}
.bg-green-300 {
  background-color: #86efac;
}
.bg-orange-500 {
  background-color: #f97316;
}
.bg-yellow-400 {
  background-color: #facc15;
}
.bg-blue-400 {
  background-color: #60a5fa;
}

/* Common bar styles */
.h-5 {
  height: 1.25rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.flex {
  display: flex;
}
.overflow-hidden {
  overflow: hidden;
}

.bg-gray-300 {
  background-color: #f3f3f3;
  padding-left: 10px;
}

.text-white {
  color: white;
}

.text-gray-800 {
  color: #333;
}

.section-labels.two-columns {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-labels.two-columns .left {
  text-align: left;
}

.section-labels.two-columns .right {
  text-align: right;
}

.section-labels.three-columns {
  display: grid;
  grid-template-columns: 1fr auto 1fr; /* left, center, right */
  align-items: center;
}

.section-labels.three-columns .left {
  text-align: left;
}

.section-labels.three-columns .center {
  text-align: center;
}

.section-labels.three-columns .right {
  text-align: right;
}

/* Shared container styles remain the same */
.progress-bar-container {
  display: flex;
  width: 100%;
  height: 20px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #e5e7eb;
}

/* CARD 1 COLORS */
.pv-consumed-yellow {
  background-color: rgb(244, 208, 63); /* yellow */
}

.pv-fed-lightyellow {
  background-color: rgba(244, 208, 63, 0.4); /* lighter yellow */
}

/* CARD 2 COLORS */
.grid-blue {
  background-color: rgb(52, 152, 219); /* blue */
}

.solar-yellow {
  background-color: rgb(244, 208, 63); /* yellow */
}

.battery-green {
  background-color: rgb(39, 174, 96); /* green */
}


.bar {
  height: 100%;
}

.pv-consumed {
  background-color: #16a34a; /* green */
}

.pv-grid {
  background-color: #86efac; /* light green */
}

.grid-consumed {
  background-color: #facc15; /* yellow */
}

.battery-consumed {
  background-color: #60a5fa; /* blue */
}

button {
  transition: background-color 0.3s;
  height: 40px; /* Set a fixed height to match the input box */
}

button:disabled {
  cursor: not-allowed;
  background-color: #b5b5b5;
}

/* Card Content */
.chat-card-content {
  display: flex;
  flex-direction: column;
  height: calc(100% - 120px); /* Adjust the height to fit within the card */
  padding-bottom: 20px; /* Ensure space for the input area */
}

/* Scrollable chat messages container */
.chat-messages-container {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 8px;
}
.energyflow-card-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 1rem;
}

.energyflow-container {
  position: relative;
  width: 100%;
  max-width: 800px;
  aspect-ratio: 2.5 / 1;
  margin-left: 8%;
  margin-top: -5%;
}

.node {
  position: absolute;
  transform: translate(-50%, -50%);
  width: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none; /* ikona nebude blokovať SVG */
}

.node svg {
  width: 40px;
  height: 40px;
  pointer-events: auto; /* ak chceš klikateľnosť ikony */
}

.node-label {
  margin-top: 85px;
  font-size: 16px;
  color: #444;
  line-height: 1.2;
  white-space: nowrap;
}

.node-label-top {
  margin-bottom: 85px; /* rovnaká vzdialenosť ako pôvodne hore */
  margin-top: -25px;
}

/* Presné pozície – optimalizované aj pre mobil */
.battery {
  left: 9%;
  top: 33%;
}
.solar {
  left: 9%;
  top: 83%;
}
.home {
  left: 44%;
  top: 59%;
}

.grid {
  left: 82%;
  top: 59%;
}

.energy-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* RESPONSIVITA */
@media (max-width: 768px) {
  .battery,
  .solar {
    left: 10%;
  }

  .grid {
    left: 85%;
  }

  .home {
    left: 50%;
  }

  .energyflow-container {
    max-width: 100%;
    aspect-ratio: 2 / 1;
  }

  .tabs-toggle-container {
    flex-direction: column;
    align-items: stretch;
  }

  .tab-buttons {
    justify-content: center;
  }

  .toggle-switch {
    justify-content: center;
  }
}

/* energy ordering plan */
.energy-table {
  border-collapse: collapse;
  border: none;
  width: max-content;
  min-width: 100%;
}

.energy-table th,
.energy-table td {
  width: 20px;
  height: 25px;
  text-align: center;
  padding: 0;
  position: relative;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
}

/* Light gray borders for 15-minute quarters */
.energy-table .quarter-border {
  border-left: 1px solid #ddd;
}

/* Black border every full hour */
.energy-table .hour-border {
  border-left: 2px solid black;
}

/* Border for last column and full table bottom */
.energy-table .last-column-border {
  border-right: 2px solid black;
}

.energy-table .row-border {
  border-top: 1px solid black;
}

.source-name {
  min-width: 130px;
  text-align: left;
  padding-left: 5px;
  background-color: #f8f8f8;
  font-weight: bold;
  border-right: 2px solid black;
  border-top: 1px solid black;
}

/* Green active cell but smaller with white padding */
.active-cell {
  background-color: transparent;
}

.active-cell {
  background-color: transparent;
  position: relative;
}

.active-cell::after {
  content: "";
  display: block;
  width: 17px;
  height: 17px;
  margin: auto;
  background-color: rgb(240, 48, 48);
  border: 1px solid white;
  border-radius: 2px;
  pointer-events: none;
}

.active-cell-paid::after {
  content: "";
  display: block;
  width: 17px;
  height: 17px;
  margin: auto;
  background-color: #f1b038;
  border: 1px solid white;
  border-radius: 2px;
  pointer-events: none;
}

.active-cell-paid-ack::after {
  content: "";
  display: block;
  width: 17px;
  height: 17px;
  margin: auto;
  background-color: #4caf50;
  border: 1px solid white;
  border-radius: 2px;
  pointer-events: none;
}

/* Current time highlight */
.current-time {
  background-color: #ffff99 !important;
}

.date-footer td {
  border-top: 2px solid black;
  border-right: 2px solid black;
  border-bottom: 2px solid black;

  text-align: center;
  background-color: #f9f9f9;
  font-weight: bold;
  padding: 4px 6px;
}

.date-cell {
  border-right: 2px solid black;
  background-color: #f9f9f9;
}

.date-footer .date-empty-cell {
  background-color: white !important;
  border: none !important; /* Reset all borders */
  border-top: 2px solid black !important;
  border-right: 2px solid black !important;
}

.energy-table tbody td:first-child {
  border-left: 2px solid black; /* or whatever color/thickness you need */
}

.energy-table thead tr:first-child th:first-child {
  border-right: 2px solid black;
  border-top: none !important;
}

.energy-table thead tr:first-child th:last-child {
  border-right: 2px solid black;
}

.scroll-table {
  overflow-x: auto; /* Enables horizontal scroll */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on mobile */
  width: 100%; /* Ensures it takes up the full width of its container */
}
.label {
  margin-top: 54px;
  font-size: 12px;
  color: #444;
  text-align: center;
}

.md-card-tabs {
  background: transparent !important;
  box-shadow: none;
}

.md-card-tabs .md-card-content {
  background: transparent !important;
  padding: 0;
}

.tab-content {
  background: transparent !important;
  padding: 16px;
  width: 100%;
}

.nav-tabs {
  background-color: transparent !important;
  box-shadow: none;
  padding: 0;
  margin: 0;
}
.md-list-item {
  background-color: transparent !important;
}
.md-layout {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.tab-content {
  max-width: 100%;
}
.tabs-button {
  background-color: white !important;
  color: white; /* optional for contrast */
}

.tabs-toggle-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  gap: 1rem;
}

.tab-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex-grow: 1;
}

/* Toggle switch layout */
.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.label-text {
  font-weight: bold;
  font-size: 14px;
  color: #1f2f40;
}

/* Actual switch */
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #4caf50;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #f9a825;
}

input:checked + .slider::before {
  transform: translateX(22px);
}

.wallet-name {
  cursor: pointer;
  position: relative;
  display: inline-block;
  font-weight: 500;
  color: #1f2f40;
}
.copy-tooltip {
  position: fixed;
  background-color: white;
  color: black;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 200;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: opacity 0.3s ease;
}

</style>